import { useNavigate, useParams } from "react-router-dom";
import { usePartnerWorkingFolderStore } from "../../../../stores/Cac/Partner/partnerWorkingFolder";
import { deleteWorkingFolder } from "../../../../services/Api/customerService";
import { usePartnerMissionStore } from "../../../../stores/Cac/Partner/partnerMission";
import { showToastError, showToastSuccess } from "../../../../services/Toasts/toasts";
import { ToastContainer } from "react-toastify";

const ModalDeleteWorkingFolder = () => {
  const { choiceModalWF, setChoiceModalWF } = usePartnerWorkingFolderStore();
  const { idCustomer, idWorkingFolder } = useParams();
  const { updateMission, setUpdateMission } = usePartnerMissionStore();
  const navigate = useNavigate();

  const handleDeleteWorkingFolder = () => {
    deleteWorkingFolder(Number(idCustomer), Number(idWorkingFolder))
      .then(() => {
        setChoiceModalWF("");
        setUpdateMission(!updateMission);
        navigate(-1);
        showToastSuccess("Le dossier de travail a bien été supprimé");
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    choiceModalWF === "delete" && (
      <>
        <ToastContainer position="top-center" />
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
          <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[45%]">
            {/* Content */}
            <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
              {/* Header */}
              <div className="w-full bg-white p-3 rounded-t-xl">
                <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Supprimer le dossier de travail
                </h4>
              </div>
              
              {/* Body */}
              <div className="w-full flex flex-col items-center justify-center text-grey-trio">
                <div className="flex flex-col justify-center items-center w-11/12 mb-6">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                    Confirmation de suppression
                  </h3>
                  <p className="text-md text-gray-600 text-center mb-2">
                    Vous êtes sur le point de supprimer le dossier de travail.
                  </p>
                  <p className="text-md text-gray-600 text-center mb-2">
                    Cette action est irréversible, et entrainera la suppression
                    des accès aux utilisateurs affectés à ce dossier.
                  </p>
                  <p className="text-sm text-gray-500 text-center mt-2 italic">
                    Êtes-vous sûr de vouloir continuer ?
                  </p>
                </div>
              </div>

              {/* Footer */}
              <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
                <button
                  className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-gray-200 cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                  type="button"
                  onClick={() => setChoiceModalWF("")}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Annuler
                </button>
                <button
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 cursor-pointer text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm"
                  type="button"
                  onClick={handleDeleteWorkingFolder}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  );
};

export default ModalDeleteWorkingFolder;
